<style lang="scss">
.attr-class {
  .comp-todolist {
    margin-bottom: 10px;
  }

  .cate-item {
    display: flex;
    align-items: center;
  }

  .comp-button {
    min-width: 80px;
  }

  .cate-name {
    width: 90px;
    margin-right: 4px;
  }
}
</style>
<template>
  <div class="attr-class">
		 <el-select
		
			 filterable
			 multiple
			 v-model="localValue"
			 placeholder= '請選擇'			 
		 >
	  <el-option
	      v-for="item in options"
	      :key="item.value"
	      :label="item.label"
	      :value="item.value">
	    </el-option>
			
		 </el-select>
  </div>
</template>

<script>
// import classifyDialog from "./classifyDialog.vue"
import { cloneDeep } from 'lodash'

import { getGradeList } from '../../../../api/membercard'
import { listVipGrade } from '../../../../api/cardticket'

export default {
  name: 'AttrClass',
  components: {},
  props: ['value','params'],
  data() {
    return {
      localValue: [],
			options:[]
    }
  },
  watch: {
    localValue: {
      handler(nVal) {
        this.$emit('input', nVal)
      },
      deep: true
    }
  },
  created() {
    this.localValue = cloneDeep(this.value)
		this.getVipList()
  },
  methods: {
     async getVipList(){
			var list = []
			if(this.params.apiParams){
				list  = await this.params.api(this.params.apiParams)
				
			}else{
				list  = await this.params.api()
			}
			
			if (this.params.key){
				list = list[this.params.key]
			}
		
			list.map((item) => {
				this.options.push({
					label:item[this.params.label],
					value:item[this.params.value],
					subTitle:item[this.params.subTitle],
				})
			})
		},
  }
}
</script>
